import type { YieldBucket } from "./apple-count-helper";

export const NUMBER_OF_COLORS = 8;

export function colorVarForBucket(
  bucketIndex: number,
  bucketCount: number,
): string {
  const colorIndex =
    bucketCount > 1
      ? Math.floor((bucketIndex * (NUMBER_OF_COLORS - 1)) / (bucketCount - 1))
      : 0;
  return "--color-apple-map-" + colorIndex;
}

export function bucketRange(buckets: YieldBucket[]): {
  min: number;
  max: number;
} {
  if (buckets.length === 0) return { min: 0, max: 0 };
  return { min: buckets[0].min, max: buckets[buckets.length - 1].max };
}
